import {
  token,
  CheckCircleOutlineMediumIcon,
  PendingOutlineMediumIcon,
} from '@ferreri/prever-component-lib';

export type BenefitsStatus = 'active' | 'pending';

export const getBenefitsStatus = (status: BenefitsStatus) => {
  return icons[status];
};

const icons = {
  active: (
    <CheckCircleOutlineMediumIcon color={token.colors.feedbackSuccessLight} />
  ),
  pending: <PendingOutlineMediumIcon color={token.colors.feedbackInfoLight} />,
};
